const toUniqueValues = (values = []) =>
  values.filter(
    (value, index) =>
      value !== undefined &&
      value !== null &&
      value !== '' &&
      values.indexOf(value) === index
  );

export const resolveManufacturerFromParam = (
  manufacturerStore,
  manufacturerParam
) => {
  if (!manufacturerParam || !manufacturerStore) {
    return null;
  }

  return manufacturerStore.manufacturersArray.find(
    (manufacturer) =>
      String(manufacturer.id) === String(manufacturerParam) ||
      manufacturer.slug === manufacturerParam ||
      manufacturer.name === manufacturerParam
  );
};

export const getManufacturerAliasValues = (
  manufacturer,
  manufacturerParam = null
) =>
  toUniqueValues(
    manufacturer
      ? [
          String(manufacturer.id),
          manufacturer.slug,
          manufacturer.name,
          manufacturerParam,
        ]
      : [manufacturerParam]
  ).map(String);

export const getCategoryManufacturerRouteState = ({
  manufacturerStore,
  manufacturerParam,
  queryManufacturerValues = [],
}) => {
  const hasManufacturerParam = Boolean(manufacturerParam);
  const manufacturerStoreLoaded = manufacturerStore?.isLoaded;
  const hasQueryManufacturerValues = queryManufacturerValues.length > 0;
  const pathManufacturer = resolveManufacturerFromParam(
    manufacturerStore,
    manufacturerParam
  );
  const aliasValues = new Set(
    getManufacturerAliasValues(pathManufacturer, manufacturerParam)
  );
  const duplicateQueryManufacturerValues = pathManufacturer
    ? queryManufacturerValues.filter((value) => aliasValues.has(String(value)))
    : [];
  const remainingQueryManufacturerValues = pathManufacturer
    ? queryManufacturerValues.filter((value) => !aliasValues.has(String(value)))
    : [...queryManufacturerValues];
  const pendingManufacturerValidation =
    hasManufacturerParam &&
    !hasQueryManufacturerValues &&
    !manufacturerStoreLoaded;
  const shouldKeepManufacturerPath =
    hasManufacturerParam &&
    manufacturerStoreLoaded &&
    Boolean(pathManufacturer) &&
    remainingQueryManufacturerValues.length === 0;
  const cleanedQueryManufacturerValues = shouldKeepManufacturerPath
    ? remainingQueryManufacturerValues
    : [...queryManufacturerValues];

  return {
    pathManufacturer,
    duplicateQueryManufacturerValues,
    remainingQueryManufacturerValues,
    cleanedQueryManufacturerValues,
    hasQueryManufacturerValues,
    pendingManufacturerValidation,
    shouldKeepManufacturerPath,
    shouldRemoveManufacturerPath:
      hasManufacturerParam &&
      !pendingManufacturerValidation &&
      !shouldKeepManufacturerPath,
    shouldStripDuplicateQueryManufacturers:
      shouldKeepManufacturerPath && duplicateQueryManufacturerValues.length > 0,
    effectiveManufacturerParam: shouldKeepManufacturerPath
      ? manufacturerParam
      : null,
  };
};

export const appendCategoryManufacturerPathSuffix = (
  basePath,
  manufacturerParam = null
) => {
  if (!manufacturerParam) {
    return basePath;
  }

  const normalizedBase = basePath.endsWith('/')
    ? basePath.slice(0, -1)
    : basePath;

  return `${normalizedBase}/${manufacturerParam}/`;
};
